import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

export function PriceChart({ ticks }: { ticks: { ts: string; yes_price_cents: number }[] }) {
  const data = ticks.map((t) => ({
    t: new Date(t.ts).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric" }),
    yes: t.yes_price_cents,
  }));
  if (!data.length) {
    return (
      <div className="chart-box" style={{ display: "grid", placeItems: "center", color: "var(--muted)" }}>
        Probability history will plot after the first tick.
      </div>
    );
  }
  return (
    <div className="chart-box" role="img" aria-label="Probability chart">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data}>
          <XAxis dataKey="t" hide />
          <YAxis domain={[0, 100]} width={32} />
          <Tooltip />
          <Line type="monotone" dataKey="yes" stroke="#FF7A00" strokeWidth={2} dot={false} name="YES %" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
